import styled from 'styled-components';
import { Hymn } from '../../../common/src/model.ts';
import BackArrow from '../assets/arrow-previous-left-icon.svg?react';
import './song_info.css';

interface Props {
  hymn: Hymn;
  back: () => void;
}

export const SongInfo = (props: Props) => {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <BackBar>
        <div onClick={() => props.back()}>
          <BackArrow className="backArrow" />
        </div>
      </BackBar>
      <div className="allInfo">
        {props.hymn.author && (
          <div className="infoChunk">
            <div className="category">Author</div>
            <div className="info">{props.hymn.author}</div>
          </div>
        )}
        {props.hymn.composer && (
          <div className="infoChunk">
            <div className="category">Composer</div>
            <div className="info">{props.hymn.composer}</div>
          </div>
        )}
        {props.hymn.harmony && (
          <div className="infoChunk">
            <div className="category">Harmony</div>
            <div className="info">{props.hymn.harmony}</div>
          </div>
        )}
        {props.hymn.copyright && (
          <div className="infoChunk">
            <div className="category">Copyright</div>
            <div className="info">{props.hymn.copyright}</div>
          </div>
        )}
      </div>
    </div>
  );
};

// Pinned to the top of the sheet, so the back arrow stays reachable when the sheet scrolls (landscape, a long
// copyright); the arrow is positioned inside it, and the info starts below it
const BackBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  height: 50px;
  background-color: var(--color-background);
`;
